import { getConstant } from '../utils';

export const getNormative = getConstant('GET_NORMATIVE');
export const getNormatives = getConstant('GET_NORMATIVES');
export const clearNormative = getConstant('CLEAR_NORMATIVE');
export const updateNormative = getConstant('UPDATE_NORMATIVE');
export const addNormative = getConstant('ADD_NORMATIVE');
